<template>
    <div ref="filters" id="filters">
        <div class="filters-content" @click="toggle()">
            <slot name="content" />
        </div>
        <div class="filters-dropdown" :class="[align]" v-if="isActive" ref="filterDropdown">
            <div class="filter-dropdown-head">
                <div class="filter-dropdown-back">
                    <span class="material-icons" @click="back()">
                        {{ operators || selectedInput || !selectable ? "arrow_back_ios" : "" }}
                    </span>
                </div>
                <div class="title">{{ $t("message.filters") }}</div>
                <span
                    class="material-icons"
                    style="font-size: 22px; font-weight: bold; cursor: pointer"
                    @click="toggle()"
                    >close</span
                >
            </div>
            <div
                class="filter-dropdown-content"
                :style="{
                    transform: operators ? 'translate(-600px)' : selectedInput ? 'translate(-300px)' : 'translate(0)',
                }"
            >
                <div class="filter-dropdown-first item">
                    <div class="filters-items">
                        <div class="filters-item" v-for="item of getItems()">
                            <div class="filters-item-name" @click="selectItem(item)">
                                <div class="material-icons">{{ item.material_icons }}</div>
                                {{ item.name }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="filter-dropdown-second item">
                    <div class="filters-items" v-if="selectedItem && selectedItem.optionSelect">
                        <div class="filters-item" v-for="option of getItemOptions(selectedItem)">
                            <div class="filters-item-name" @click="selectOption(option)">
                                {{ option.value }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="filter-dropdown-third item">
                    <div class="filters-items" v-if="selectedItem">
                        <div class="filters-item" v-for="operator of getOperators()">
                            <div class="filters-item-name" @click="selectOperator(operator)">
                                {{ OPERATORS_TYPES[operator] }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import MiniFilterPreview from "./MiniFilterPreview.vue";

const INPUT_TYPES = {
    TEXT: "text",
    SELECT: "select",
    DATE: "date",
};

const EMPTY_TYPES = ["is_empty", "is_not_empty"];

const PERIOD_TYPES = {
    TODAY: "today",
    YESTERDAY: "yesterday",
    THIS_WEEK: "thisWeek",
    PAST_WEEK: "pastWeek",
    THIS_MONTH: "thisMonth",
    PAST_MONTH: "pastMonth",
    CUSTOM: "custom",
};

export default {
    name: "Filters",
    components: {
        MiniFilterPreview,
    },
    props: {
        align: {
            type: String,
            default: "top",
        },
        items: {
            type: Array,
            default: () => [],
        },
        value: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            INPUT_TYPES,
            OPERATORS_TYPES: {
                is: this.$t("chatbotv2.filters.equal"),
                is_not: this.$t("chatbotv2.filters.not_equal"),
                contains: this.$t("chatbotv2.filters.contain"),
                not_contains: this.$t("chatbotv2.filters.not_contain"),
                starts_with: this.$t("chatbotv2.filters.starts_with"),
                ends_with: this.$t("chatbotv2.filters.ends_with"),
                is_empty: this.$t("chatbotv2.filters.empty"),
                is_not_empty: this.$t("chatbotv2.filters.non_empty"),
                less_than: this.$t("chatbotv2.filters.less_than"),
                less_or_equal: this.$t("chatbotv2.filters.less_or_equal"),
                greater_than: this.$t("chatbotv2.filters.greater_than"),
                greater_or_equal: this.$t("chatbotv2.filters.greater_or_equal"),
            },
            PERIOD_TYPES,
            EMPTY_TYPES,
            isActive: false,
            selectable: true,
            filters: [],
            filtered: [],
            operators: false,
            selectedItem: null,
            selectedInput: false,
        };
    },
    methods: {
        getItems() {
            const items = this.items;
            return items.filter((item) => {
                const isSingleton = item.singleton;
                const isUsed = this.filters.find((f) => f.key === item.key);
                return isSingleton ? !isUsed : true;
            });
        },
        toggle() {
            this.isActive = !this.isActive;
            if (this.isActive) this.$refs.filters?.focus();
        },
        back() {
            if (this.operators) {
                this.operators = false;
                this.selectedInput = !!item.optionSelect;
                return;
            }
            this.selectedInput = false;
            this.selectable = true;
            this.selectedItem = null;
        },
        selectedFilters() {
            this.filters = [
                ...this.filters,
                {
                    ...this.selectedItem,
                    value: this.selectedItem.defaultValue,
                },
            ];
            this.$emit("input", this.filters);
            this.selectable = true;
            this.isActive = false;
            this.selectedItem = null;
        },
        getItemOptions(item) {
            return item.options;
        },
        selectItem(item) {
            this.selectedItem = item;
            if (item.optionSelect) {
                this.selectedInput = true;
                this.selectedItem = item;
                return;
            } else if (item.operators) {
                this.operators = true;
                item.rule = null;
                this.selectedItem = item;
                return;
            }
            this.selectedFilters();
        },
        getOperators() {
            const isProperty = this.selectedItem?.type === "contact-property-selector";
            if (isProperty) {
                const inputType = this.selectedItem.options.find((o) => o.key === this.selectedItem.input)?.type;
                const availableOperatorsByType = {
                    text: ["is", "is_not", "contains", "not_contains", "is_empty", "is_not_empty"],
                    dropdown: ["is", "is_not", "is_empty", "is_not_empty"],
                    email: ["is", "is_not", "contains", "not_contains", "is_empty", "is_not_empty"],
                    phone: ["is", "is_not", "contains", "not_contains", "is_empty", "is_not_empty"],
                    number: [
                        "is",
                        "is_not",
                        "is_empty",
                        "is_not_empty",
                        "less_than",
                        "less_or_equal",
                        "greater_than",
                        "greater_or_equal",
                    ],
                    url: ["is", "is_not", "contains", "not_contains", "is_empty", "is_not_empty"],
                    date: [
                        "is",
                        "is_not",
                        "is_empty",
                        "is_not_empty",
                        "less_than",
                        "less_or_equal",
                        "greater_than",
                        "greater_or_equal",
                    ],
                };
                const defaultOperators = ["is", "is_not", "is_empty", "is_not_empty"];
                return availableOperatorsByType[inputType] || defaultOperators;
            }
            // optionSelect olan filtrelerde (örn. metaReferralField) aynı key altında
            // farklı input'lar için aynı operator'ün tekrar eklenebilmesi gerekiyor;
            // bu yüzden duplicate kontrolünü input+rule kombinasyonuna göre yapıyoruz.
            let usedOperators;
            if (this.selectedItem.optionSelect && this.selectedItem.input) {
                usedOperators =
                    this.filters
                        .filter((f) => f.key === this.selectedItem.key && f.input === this.selectedItem.input)
                        .map((f) => f.rule) || [];
            } else {
                usedOperators = this.filters.filter((f) => f.key === this.selectedItem.key).map((f) => f.rule) || [];
            }
            return Object.keys(this.OPERATORS_TYPES).filter(
                (operator) => ![...usedOperators, ...(this.selectedItem?.omitOperators || [])].includes(operator)
            );
        },
        selectOption(option) {
            this.selectedItem.input = option.key;
            this.selectedInput = false;
            if (this.selectedItem.operators) {
                this.operators = true;
                return;
            }
            this.selectedFilters();
        },
        selectOperator(rule) {
            this.selectedItem.rule = rule;
            this.operators = false;
            this.selectedFilters();
        },
    },
    mounted() {
        document.addEventListener("click", (e) => {
            if (!this.$refs.filters?.contains(e.target)) {
                this.isActive = false;
            }
        });
        this.filters = [...this.value];
    },
    watch: {
        value(val) {
            this.filters = val;
        },
    },
};
</script>
<style lang="scss">
#filters {
    position: relative;
    width: 100%;
    user-select: none;
    display: block;

    span {
        display: block;
    }

    .filter-dropdown-back {
        .material-icons {
            cursor: pointer;
        }
    }

    .filters-dropdown {
        position: absolute;
        background-color: #ffffff;
        border: 1px solid #e8e8e8;
        border-radius: 8px;
        width: 300px !important;
        z-index: 9999;
        overflow: hidden;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

        .filter-dropdown-head {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 12px 16px;
            background: #ffffff;
            border-bottom: 1px solid #f0f0f0;

            .material-icons {
                font-size: 18px;
                font-weight: 500;
                color: #1e1e2d;
                transition: color 0.2s ease;
                cursor: pointer;

                &:hover {
                    color: #5625CC;
                }
            }

            .title {
                font-size: 14px;
                font-weight: 600;
                color: #1e1e2d;
            }
        }

        &.bottom {
            top: calc(100% + 4px);
        }

        &.top {
            bottom: calc(100% + 4px);
        }

        .filters-head {
            display: flex;
            width: 300px !important;
            align-items: center;
            justify-content: center;
            background: #1e1e2d;
            padding: 4px 15px;
            border-radius: 5px 5px 0px 0px;
            color: white;
            font-weight: bold;
            font-size: 14px;
        }

        .filter-dropdown-content {
            width: 300px;
            display: flex;
            transition: all 0.3s ease 0s;

            .item {
                min-width: 300px;
            }
        }

        .filters-items {
            height: 350px;
            overflow: auto;
            padding: 6px 0;

            .filters-item {
                padding: 11px 20px;
                color: #1e1e2d;
                border-bottom: 1px solid #f5f5f5;
                transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
                cursor: pointer;
                background-color: #ffffff;

                &:last-child {
                    border: none;
                }

                &:hover {
                    background-color: #EEE7FF;
                    color: #5625CC;
                }

                .material-icons {
                    margin-right: 12px;
                    font-size: 20px;
                    transition: color 0.2s ease;
                }
            }

            .filters-item-name {
                display: flex;
                align-items: center;
                font-size: 14px;
                font-weight: 400;
                cursor: pointer;
                transition: color 0.2s ease;
            }
        }
    }
}
</style>
